'use client';
import { createI18nClient } from 'next-international/client';

const translationCache: Record<string, any> = {};

async function fetchTranslations(locale: string): Promise<any> {
  if (translationCache[locale]) {
    return translationCache[locale];
  }

  const baseUrl = process.env.NEXT_PUBLIC_HOSTNAME;
  const url = `${baseUrl}/translations?lang=${locale}`;

  try {
    const response = await fetch(url);

    if (!response.ok) {
      throw new Error(`Failed to fetch locale for ${locale}`);
    }
    const data = await response.json();
    const transformedData = transformLocalizationData(data);

    translationCache[locale] = { default: transformedData };
    return translationCache[locale];
  } catch (error) {
    console.error('Error fetching locale:', error);
    throw error;
  }
}

function transformLocalizationData(
  data: any,
  prefix = ''
): Record<string, string> {
  let result: Record<string, string> = {};
  for (let key in data) {
    if (typeof data[key] === 'object' && data[key] !== null) {
      const nestedKeys = transformLocalizationData(
        data[key],
        `${prefix}${key}.`
      );
      result = { ...result, ...nestedKeys };
    } else {
      result[`${prefix}${key}`] = data[key];
    }
  }
  return result;
}

export const {
  useI18n,
  useScopedI18n,
  I18nProviderClient,
  useChangeLocale,
  useCurrentLocale,
  ...restI18n
} = createI18nClient({
  en: () => fetchTranslations('en'),
  ru: () => fetchTranslations('ru'),
  uk: () => fetchTranslations('uk'),
  kz: () => fetchTranslations('kz'),
  de: () => fetchTranslations('de'),
  ro: () => fetchTranslations('ro'),
  uz: () => fetchTranslations('uz'),
});
